const LOCALHOST = ['localhost', '127.0.0.1'];

let ENV = 'develop';
let API_BASE_URL = '/travel/trc-service';
let D360_BASE_URL = 'https://test.flysas.com';
const { hostname } = window.location;

if (LOCALHOST.indexOf(hostname) > -1) {
  API_BASE_URL = 'http://localhost:3000';
}

if (LOCALHOST.indexOf(hostname) < 0) {
  ENV = 'production';
  D360_BASE_URL = 'https://www.flysas.com';
}

const isPROD = ENV === 'production';

export default { API_BASE_URL, D360_BASE_URL, ENV, isPROD };
